<template>
  <div>
    <div class="d-flex mb-6 align-center" style="gap: 10px">
      <div
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
          width: '59.42px',
          height: '32.5px',
          borderRadius: '10px',
        }"
      >
        <v-btn size="small" color="button " @click="save" elevation="0"
          >Save</v-btn
        >
      </div>

      <v-btn size="small" text @click="$router.go(-1)"
        >Close without saving</v-btn
      >
    </div>

    <h1 class="mb-4">Template</h1>
    <div class="editor" v-if="!loading">
      <v-card
        flat
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div>
          <v-sheet
            class="px-6 d-flex justify-center align-center py-2"
            color="accent"
            style="
              font-size: 10pt;
              font-weight: 600;
              border-top-right-radius: 7px;
              border-top-left-radius: 7px;
            "
          >
            Details
          </v-sheet>
          <v-divider class="primary"> </v-divider>
        </div>

        <div class="py-2">
          <div class="px-4 py-2">
            <v-text-field
              label="Title"
              style="border-radius: 6px; font-size: 10pt"
              flat
              class=""
              variant="solo"
              v-model="name"
              hide-details=""
            ></v-text-field>
          </div>

          <v-divider></v-divider>

          <div class="px-4 py-2">
            <v-select
              style="border-radius: 6px; font-size: 10pt"
              label="Tags"
              hide-details=""
              variant="solo"
              density="compact"
              multiple
              v-model="tags"
              :items="[
                'Blog',
                'Did you know',
                'FAQ',
                'General',
                'Graphs',
                'Link share',
                'Polls',
                'Updates',
                'Quotes',
                'Tips',
              ]"
              flat
            ></v-select>
          </div>

          <v-divider></v-divider>

          <div class="px-4 py-4">
            <v-btn
              v-if="!background.type"
              elevation="0"
              block
              size="small"
              @click="openMediaDrawer('template.background')"
              >Add background</v-btn
            >
            <v-card v-else variant="outlined" class="py-2 px-4 upload">
              <p
                class="mb-0"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 10pt;
                "
                v-if="background.type"
              >
                {{ background.title }}
              </p>

              <v-btn
                v-if="background.type"
                class="bg-smoke"
                flat
                size="small"
                icon="mdi-image-refresh"
                @click="openMediaDrawer('template.background')"
              ></v-btn>
            </v-card>
          </div>

          <v-divider></v-divider>

          <div class="edit-item px-4 py-4">
            <div>
              <v-btn-toggle dense v-model="align_items">
                <v-btn value="flex-start" color="white">
                  <v-icon size="small">mdi-format-align-top</v-icon>
                </v-btn>
                <v-btn value="center" color="white">
                  <v-icon size="small">mdi-format-align-middle</v-icon>
                </v-btn>
                <v-btn value="flex-end" color="white">
                  <v-icon size="small">mdi-format-align-bottom</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="px-4 py-2">
            <v-select
              v-model="aspect_ratio"
              variant="solo"
              flat
              return-object
              hide-details=""
              density="compact"
              label="Aspect ratio"
              item-title="text"
              :items="aspect_ratios"
            ></v-select>
          </div>
          <v-divider></v-divider>
          <div class="pa-4">
            <div>
              <div class="sliders">
                <v-slider
                  dense
                  prepend-icon="mdi-align-vertical-distribute"
                  hide-details=""
                  v-model="padding.y"
                ></v-slider>
                <v-slider
                  dense
                  prepend-icon="mdi-align-horizontal-distribute"
                  hide-details=""
                  v-model="padding.x"
                ></v-slider>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div>
          <v-sheet
            class="px-6 d-flex justify-center align-center py-2"
            color="accent"
            style="
              font-size: 10pt;
              font-weight: 600;
              border-top-right-radius: 7px;
              border-top-left-radius: 7px;
            "
          >
            Blocks
          </v-sheet>
          <v-divider class="primary"> </v-divider>
        </div>
        <div class="blocks-list d-flex flex-column justify-space-between">
          <!-- <p
            v-if="blocks.length > 0"
            class="py-2 mb-0 text-center align-center"
            style="font-size: 9pt"
          >
            <v-icon color="primary" class="mr-1 mb-1" size="x-small"
              >mdi-arrow-up-down</v-icon
            >
            <i>Drag blocks to order</i>
          </p> -->
          <div>
            <draggable
              class="blocks"
              v-model="blocks"
              @start="drag = true"
              @end="drag = false"
              ghost-class="ghost"
              handle=".drag-handle"
              tag="div"
              :item-key="(item, index) => index"
            >
              <template #item="{ element, index }">
                <div>
                  <v-menu
                    v-model="element.menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    max-width="300"
                    offset-y
                  >
                    <template v-slot:activator="{ props }">
                      <v-list-item
                        v-bind="props"
                        block
                        elevation="0"
                        tile
                        style="width: 100%"
                        class="px-2 mx-0"
                      >
                        <div class="d-flex align-center px-3">
                          <v-icon class="mr-3 drag-handle" size="small"
                            >mdi-drag</v-icon
                          >
                          <!-- <v-icon class="mr-1" size="small">{{
                          element.type === "image" ? "mdi-image" : "mdi-pencil"
                        }}</v-icon> -->
                          <p style="font-size: 12px" class="mb-0 mr-auto">
                            {{
                              element.type === "image"
                                ? element.media
                                  ? element.media.title
                                  : "Image block"
                                : element.text
                            }}
                          </p>
                          <v-icon size="x-small">mdi-pencil</v-icon>
                        </div>
                      </v-list-item>
                    </template>

                    <v-card class="smoke">
                      <div v-if="element.type === 'image'" class="pa-4">
                        <div class="block">
                          <div v-if="!element.media">
                            <v-btn
                              color="button"
                              class="primary--text ml-2"
                              elevation="0"
                              size="small"
                              @click="
                                openMediaDrawer(`template.block.${index}`)
                              "
                              >Add media</v-btn
                            >
                          </div>
                          <v-card v-else outlined class="py-2 px-4 upload">
                            <p
                              class="mb-0"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-size: 10pt;
                              "
                            >
                              {{ element.media.title }}
                            </p>

                            <v-btn
                              class="smoke"
                              icon
                              @click="
                                openMediaDrawer(`template.block.${index}`)
                              "
                              ><v-icon size="20"
                                >mdi-image-refresh</v-icon
                              ></v-btn
                            >
                          </v-card>
                        </div>

                        <div>
                          <v-select
                            v-model="element.position"
                            :items="['relative', 'absolute']"
                          ></v-select>
                          <v-slider
                            label="Size"
                            v-model="element.width"
                            hide-details=""
                          ></v-slider>
                        </div>

                        <div>
                          <v-slider
                            v-model="element.margin.y"
                            label="margin y"
                            min="0"
                            max="30"
                          ></v-slider>
                          {{ element.margin.y }}
                          <v-slider
                            v-model="element.margin.x"
                            label="margin x"
                          ></v-slider>
                        </div>

                        <div
                          v-if="element.position === 'absolute'"
                          class="d-flex"
                        >
                          <v-text-field
                            v-model="element.top"
                            type="number"
                          ></v-text-field>
                          <v-text-field
                            v-model="element.left"
                            type="number"
                          ></v-text-field>
                        </div>
                        <div>
                          <v-slider
                            label="Dropshadow"
                            v-model="element.dropshadow"
                            hide-details=""
                            min="0"
                            max="10"
                          ></v-slider>
                          <v-slider
                            label="Opacity"
                            v-model="element.opacity"
                            hide-details=""
                            min="0"
                            max="1"
                            step="0.1"
                          ></v-slider>
                        </div>
                        <div class="mt-4" v-if="element.media">
                          <p style="font-size: 10pt" class="mb-1">Placement:</p>
                          <v-btn-toggle v-model="element.align" dense>
                            <v-btn
                              size="small"
                              value="flex-start"
                              elevation="0"
                            >
                              <v-icon size="small"
                                >mdi-format-vertical-align-top</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" value="center" elevation="0">
                              <v-icon size="small"
                                >mdi-format-vertical-align-center</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" value="flex-end" elevation="0">
                              <v-icon size="small"
                                >mdi-format-vertical-align-bottom</v-icon
                              >
                            </v-btn>
                          </v-btn-toggle>
                          <v-btn-toggle v-model="element.justify" dense>
                            <v-btn
                              size="small"
                              value="flex-start"
                              elevation="0"
                            >
                              <v-icon size="small"
                                >mdi-format-horizontal-align-left</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" value="center" elevation="0">
                              <v-icon size="small"
                                >mdi-format-horizontal-align-center</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" value="flex-end" elevation="0">
                              <v-icon size="small"
                                >mdi-format-horizontal-align-right</v-icon
                              >
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                      </div>

                      <div class="pa-4" v-if="element.type === 'text'">
                        <div>
                          <v-text-field
                            variant="solo"
                            bg-color="smoke"
                            label="Text"
                            flat
                            style="border-radius: 6px; font-size: 10pt"
                            hide-details=""
                            v-model="element.text"
                            full-width
                          ></v-text-field>
                        </div>

                        <div class="pa-2 d-flex align-center" style="gap: 5px">
                          <p style="font-size: 10pt" class="mb-0 mt-1">
                            Font size:
                          </p>
                          <v-slider
                            class="mt-2"
                            v-model="element.font.size"
                            hide-details=""
                          ></v-slider>
                        </div>

                        <div class="pa-2 d-flex align-center" style="gap: 5px">
                          <p style="font-size: 10pt" class="mb-0 mt-1">
                            Font weight:
                          </p>
                          <v-slider
                            v-model="element.font.weight"
                            hide-details=""
                            :min="300"
                            :max="900"
                            :step="100"
                          ></v-slider>
                        </div>

                        <div class="pa-2 d-flex align-center" style="gap: 5px">
                          <p style="font-size: 10pt" class="mb-0 mt-1">
                            Line height:
                          </p>
                          <v-slider
                            class="mt-2"
                            v-model="element.line_height"
                            hide-details=""
                            min="10"
                            max="200"
                          ></v-slider>
                        </div>

                        <div>
                          <v-slider
                            v-model="element.margin.y"
                            label="margin y"
                            min="0"
                            max="30"
                          ></v-slider>
                          {{ element.margin.y }}
                          <v-slider
                            v-model="element.margin.x"
                            label="margin x"
                          ></v-slider>
                        </div>

                        <div class="pa-2">
                          <p class="mb-1" style="font-size: 10pt">Styling:</p>
                          <v-btn-toggle v-model="element.text_align" dense>
                            <v-btn size="small" elevation="0" value="left">
                              <v-icon size="small"
                                >mdi-format-align-left</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" elevation="0" value="center">
                              <v-icon size="small"
                                >mdi-format-align-center</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" elevation="0" value="right">
                              <v-icon size="small"
                                >mdi-format-align-right</v-icon
                              >
                            </v-btn>

                            <v-btn size="small" elevation="0" value="justify">
                              <v-icon size="small"
                                >mdi-format-align-justify</v-icon
                              >
                            </v-btn>
                          </v-btn-toggle>
                          <v-btn-toggle
                            v-model="element.format"
                            dense
                            bg-color="smoke"
                            multiple
                          >
                            <v-btn size="small" value="italic">
                              <v-icon size="small">mdi-format-italic</v-icon>
                            </v-btn>
                            <v-btn size="small" value="underline">
                              <v-icon size="small">mdi-format-underline</v-icon>
                            </v-btn>
                            <ColorPicker :index="index" @color="pickColor" />
                          </v-btn-toggle>

                          <div>
                            <p class="mb-1" style="font-size: 10pt">Card:</p>
                            <v-checkbox
                              label="Add card"
                              v-model="element.card.value"
                              hide-details=""
                            ></v-checkbox>
                            <v-checkbox
                              label="Add drop shadow"
                              hide-details=""
                              v-model="element.card.drop"
                            ></v-checkbox>

                            <v-slider
                              dense
                              prepend-icon="mdi-image-size-select-small"
                              hide-details=""
                              v-model="element.card.size"
                            ></v-slider>
                          </div>
                        </div>
                      </div>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn
                          size="small"
                          icon
                          @click.stop="blocks.splice(i, 1)"
                        >
                          <v-icon size="small">mdi-delete</v-icon></v-btn
                        >
                        <!-- <v-spacer></v-spacer>

                      <v-btn size="small" text @click="b.menu = false"> Cancel </v-btn>
                      <v-btn size="small" color="primary" text @click="b.menu = false">
                        Apply
                      </v-btn> -->
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </div>
              </template>
            </draggable>
          </div>
          <v-spacer></v-spacer>
          <div>
            <v-divider></v-divider>
            <div class="edit-item pa-4">
              <v-btn block elevation="0" size="small" @click="addBlock('text')">
                Add Text
              </v-btn>
              <v-btn
                block
                elevation="0"
                size="small"
                @click="addBlock('image')"
              >
                Add Image
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>

      <div>
        <v-card
          flat
          :style="{
            borderBottom: '3px solid #272727',
            borderLeft: '1px solid #272727',
            borderTop: '1px solid #272727',
            borderRight: '3px solid #272727',
          }"
          style="max-width: 500px"
        >
          <div>
            <v-sheet
              class="px-6 d-flex justify-center align-center py-2"
              color="accent"
              style="
                font-size: 10pt;
                font-weight: 600;
                border-top-right-radius: 7px;
                border-top-left-radius: 7px;
              "
            >
              Preview
            </v-sheet>
          </div>
          <v-divider class="bg-primary"> </v-divider>
          <Preview :template="template" />
        </v-card>
      </div>
    </div>
    <div v-else-if="loading">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { template } from "@/mixins/template";
import draggable from "vuedraggable";
import ColorPicker from "@/components/ColorPicker.vue";
import {
  addDoc,
  collection,
  doc,
  setDoc,
  arrayUnion,
  updateDoc,
} from "firebase/firestore";
import { db } from "@/firebase";
import * as htmlToImage from "html-to-image";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import Preview from "@/components/templates/PreviewComp.vue";

export default {
  mixins: [template],
  components: {
    Preview,
    draggable,
    ColorPicker,
  },
  mounted() {
    if (this.$route.params.id && this.$route.params.id != "new") {
      this.$store.dispatch("setTemplate", this.$route.params.id);
    }
  },
  data() {
    return {
      aspect_ratios: [
        {
          text: "Original",
          value: null,
        },
        {
          text: "16:9",
          value: 1.777,
        },
        {
          text: "1:1",
          value: 1,
        },
      ],

      changes: true,
      drag: false,
      media_drawer: false,
      media_drawer_block: null,
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
    }),
    template() {
      return {
        uid: this.uid,
        justify_content: this.justify_content,
        background: this.background,
        tags: this.tags,
        align_items: this.align_items,
        blocks: this.blocks,
        padding: this.padding,
        name: this.name,
        aspect_ratio: this.aspect_ratio,
        thumbnail: null,
        created_by: this.created_by,
        created_by_email: this.created_by_email,
        created_at: this.created_at,
        type: "template",
        workspace: this.userProfile.workspace,
        extension: "png",
      };
    },
  },
  methods: {
    addBlock(type) {
      if (type === "image") {
        this.blocks.push({
          media: null,
          width: 20,
          menu: false,
          type: "image",
          margin: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            x: 0,
            y: 0,
          },
          top: 0,
          left: 0,
          position: "relative",
          align: "center",
          justify: "center",
          title: "Image",
          opacity: 1,
          dropshadow: 0,
        });
      } else if (type === "text") {
        this.blocks.push({
          text: "Lorem ipsum...",
          type: "text",
          color: "#c4c4c4",
          menu: false,
          card: {
            value: false,
            size: 12,
            color: "#fff",
            drop: false,
          },
          line_height: 100,
          font: {
            size: 30,
            weight: 500,
          },
          margin: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            x: 0,
            y: 0,
          },
        });
      }
    },
    change(v) {
      if (v === false) {
        console.log("Closing Editor");
        this.$store.commit("clearTemplate");
      }
    },
    pickColor(i) {
      console.log(i);
      this.blocks[i.index].color = i.color;
    },
    async save() {
      if (this.uid) {
        this.updateTemplate();
      } else {
        this.created_at = Math.floor(Date.now() / 1000);
        this.created_by = this.userProfile.uid;
        this.created_by_email = this.userProfile.email;

        const docRef = await addDoc(
          collection(db, "workspaces", this.userProfile.workspace, "templates"),
          this.template
        );
        console.log("New Template written with ID: ", docRef.id);
        await updateDoc(
          doc(
            db,
            "workspaces",
            this.userProfile.workspace,
            "templates",
            docRef.id
          ),
          {
            uid: docRef.id,
          }
        );

        let template = await htmlToImage.toPng(
          document.getElementById("my-node"),
          { quality: 1 }
        );

        const storeTemplate = httpsCallable(functions, "storeTemplate");
        const res = await storeTemplate({
          base64Image: template,
          uid: docRef.id,
        });

        await updateDoc(
          doc(
            db,
            "workspaces",
            this.userProfile.workspace,
            "templates",
            docRef.id
          ),
          {
            thumbnail: res.data.thumbnail ? res.data.thumbnail : null,
          }
        );
        this.thumbnail = res.data.thumbnail;

        this.$store.commit("setNotification", {
          show: true,
          text: "Template saved!",
          type: "primary",
          icon: "",
        });
        this.$store.dispatch("fetchTemplates");
        this.$router.go(-1);
      }
    },
    openMediaDrawer(type) {
      console.log(type);
      this.$store.commit("setMediumType", type);
    },
    async updateTemplate() {
      const ref = doc(
        db,
        "workspaces",
        this.userProfile.workspace,
        "templates",
        this.uid
      );

      setDoc(ref, this.template, { merge: true });
      let template = await htmlToImage.toPng(
        document.getElementById("my-node"),
        { quality: 1 }
      );

      const storeTemplate = httpsCallable(functions, "storeTemplate");
      await storeTemplate({
        base64Image: template,
        uid: this.uid,
      });

      this.blocks.map(async (b) => {
        if (b.type === "image" && b.media.uid) {
          await updateDoc(
            doc(
              db,
              "workspaces",
              this.userProfile.workspace,
              "media",
              b.media.uid
            ),
            {
              templates: arrayUnion(this.uid),
            }
          );
        }
      });
      // TODO REMOVE WHEN BLOCKS ARE REMOVED WHERE MEDIA IS USED

      this.$store.commit("setNotification", {
        show: true,
        text: "Template saved!",
        type: "primary",
        icon: "",
      });
      this.$store.commit("clearTemplate");
      this.$store.dispatch("fetchTemplates");
      this.$router.push("/library/templates");
      console.log("template updated");
    },
  },
};
</script>

<style lang="scss" scoped>
.editor {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: 10px;
  max-width: 1200px;
}

.edit-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.blocks {
  display: flex;

  flex-direction: column;
  gap: 3px;
}

.blocks-list {
  height: calc(100% - 36px);
}
.upload {
  display: grid;
  grid-template-columns: auto 40px;
  align-items: center;
}

.template_background {
  width: 100%;
  background-color: #fff;
}
</style>
